import { Stack } from "@mui/material";
import { DashboardTile } from "components/Dashboard/DashboardTile";

import { useWasteOverviewState } from "../WasteOverviewContext";
import TsdfChart from "./Charts/TotalQuantityByTsdfChart";

export function TsdfTile() {
  const {
    overviewState: { isPending },
  } = useWasteOverviewState();

  return (
    <DashboardTile size={{ xs: 12, md: 6, lg: 6, xl: 7 }} sx={{ opacity: isPending ? 0.5 : 1 }}>
      <DashboardTile.Header
        title="TSDF"
        infoTooltip="Shows waste totals across facilities per TSDF (Treatment, Storage, and
        Disposal Facility). Totals are calculated from vendor line items, but if
        no vendor data is present, we will use e‑Manifest data."
      />
      <DashboardTile.ContentArea sx={{ flexGrow: 1 }}>
        <Stack sx={{ flex: 1, overflowX: "hidden" }}>
          <TsdfChart />
        </Stack>
      </DashboardTile.ContentArea>
    </DashboardTile>
  );
}
